import { useMediaQuery, useTheme } from '@mui/material';
import { PanelResizeHandle } from 'react-resizable-panels';

import { useFeatureFlags } from 'src/context';

export const ResizeHandle = ({
  className,
  restColorClass,
}: {
  className?: string;
  /**
   * Overrides the resting (non-hover) divider color; hover/drag feedback is
   * left untouched. Defaults to the sidebar/legacy gray.
   */
  restColorClass?: string;
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));
  const { EnableNewSidebar } = useFeatureFlags();

  if (isMobile) {
    return null;
  }

  const restBg =
    restColorClass ?? (EnableNewSidebar ? 'bg-gray-100' : 'bg-gray-200');
  const colorClasses = EnableNewSidebar
    ? `${restBg} data-[resize-handle-state=hover]:bg-gray-400 data-[resize-handle-state=drag]:bg-gray-400`
    : `${restBg} data-[resize-handle-state=hover]:bg-gray-500 data-[resize-handle-state=drag]:bg-gray-500`;

  return (
    <PanelResizeHandle
      hitAreaMargins={{ coarse: 15, fine: 5 }}
      className={`w-px h-full ${colorClasses} cursor-col-resize ${className ?? ''}`}
    />
  );
};
